var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeart2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 139.903,
    height: 118.998,
    viewBox: "0 0 139.903 118.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heart_2",
    "data-name": "heart 2",
    transform: "translate(2.5 2.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13471",
    "data-name": "Group 13471"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22295",
    fill: "#0bc1c7",
    stroke: "#fff",
    strokeWidth: "5px",
    d: "M124.277 50.08a35.761 35.761 0 0 0-25.734-10.408c-17.426 0-26.436 8.966-30.925 16.488l-.166.28-.166-.28c-4.49-7.522-13.5-16.488-30.925-16.488A35.76 35.76 0 0 0 10.626 50.08C3.675 57.12 0 66.757 0 77.949c0 23.766 21.126 39.523 39.765 53.425 9.288 6.927 18.06 13.47 23.581 20.33a5.27 5.27 0 0 0 8.21 0A80.488 80.488 0 0 1 83.981 139.9a5.27 5.27 0 0 0-6.6-8.217 113.922 113.922 0 0 0-9.927 8.827c-5.957-6.072-13.5-11.7-21.387-17.581C28.6 109.9 10.539 96.428 10.539 77.949c0-16.332 10.618-27.738 25.821-27.738 9.886 0 17.185 3.719 21.7 11.054a30.652 30.652 0 0 1 4.14 11.92 5.269 5.269 0 0 0 10.506.023 30.637 30.637 0 0 1 4.143-11.943c4.511-7.335 11.81-11.054 21.7-11.054 15.2 0 25.821 11.406 25.821 27.738 0 15.292-12.45 27.148-25.9 37.683a5.27 5.27 0 1 0 6.5 8.3c6.4-5.011 14.512-11.783 20.479-19.735 6.371-8.49 9.467-17.075 9.467-26.246-.016-11.194-3.687-20.831-10.639-27.871z",
    "data-name": "Path 22295",
    transform: "translate(0 -39.672)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart2);
export default __webpack_public_path__ + "static/media/heart_2.ce3b3eb5.svg";
export { ForwardRef as ReactComponent };